module.exports = __webpack_public_path__ + "4a172f6e16cb76cefe874a84c8fb2b49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/policy/picmobile6.png
// module id = 1889
// module chunks = 0